import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { Button } from "./ui/button";
import { Globe, Menu, X, Phone } from "lucide-react";

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigation = [
    { key: "home", href: "/" },
    { key: "products", href: "/products" },
    // { key: "shop", href: "/shop" }, // Masqué temporairement
    { key: "sectors", href: "/sectors" },
    { key: "caseStudies", href: "/case-studies" },
    { key: "about", href: "/about" },
    { key: "resources", href: "/resources" },
    { key: "contact", href: "/contact" }
  ];

  const isActive = (href) => {
    return location.pathname === href;
  };

  return (
    <header className="bg-white border-b-2 border-excel-light-gray sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 hover:opacity-80 transition-opacity">
            <img
              src="https://customer-assets.emergentagent.com/job_excel-levage/artifacts/kps9q4zc_Logo%20Excel%20Levage%20-%20Version%20Finale%20Corrig%C3%A9e.svg"
              alt="Excel Levage"
              className="h-24 w-auto drop-shadow-sm"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            {navigation.slice(0, 6).map((item) => (
              <Link
                key={item.key}
                to={item.href}
                className={`text-sm font-semibold transition-colors duration-200 hover:text-excel-red py-2 ${
                  isActive(item.href)
                    ? "text-excel-red border-b-2 border-excel-red"
                    : "text-excel-steel"
                }`}
              >
                {t(item.key)}
              </Link>
            ))}
          </nav>

          {/* Right side - Phone, Language switcher and CTA */}
          <div className="hidden md:flex items-center space-x-8">
            <div className="flex items-center space-x-2 text-excel-steel font-semibold text-sm">
              <Phone className="h-4 w-4" />
              <span>{t("phone")}</span>
            </div>

            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-1 text-excel-steel hover:text-excel-red transition-colors text-sm border border-excel-light-gray px-3 py-1 rounded"
            >
              <Globe className="h-4 w-4" />
              <span className="font-medium">{language === "fr" ? "FR" : "EN"}</span>
            </button>
            
            <Button 
              asChild 
              size="default"
              className="bg-excel-red hover:bg-excel-dark text-white px-8 py-2 font-semibold shadow-md"
            >
              <Link to="/contact">Demander un devis</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-excel-red"
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              {navigation.map((item) => (
                <Link
                  key={item.key}
                  to={item.href}
                  className={`block px-3 py-2 text-base font-medium transition-colors ${
                    isActive(item.href)
                      ? "text-excel-red bg-gray-50"
                      : "text-gray-700 hover:text-excel-red hover:bg-gray-50"
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {t(item.key)}
                </Link>
              ))}
              
              <div className="px-3 py-2 border-t">
                <button
                  onClick={toggleLanguage}
                  className="flex items-center space-x-2 text-gray-700 hover:text-excel-red mb-2 px-2 py-1 rounded"
                >
                  <Globe className="h-4 w-4" />
                  <span>{language === "fr" ? "FR" : "EN"}</span>
                </button>
                
                <div className="text-excel-red font-medium mb-2">
                  {t("phone")}
                </div>
                
                <Button 
                  asChild 
                  className="w-full bg-excel-light-red hover:bg-excel-red text-white"
                >
                  <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                    {t("getQuote")}
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;